module.exports = __webpack_public_path__ + "static/media/CloudUploadOutlined.73406bb0.svg";